import React from "react";
import Banner from "../../components/Banner/Banner";
import Features from "../../components/Features/Features";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import imgExperience from "../../assets/images/new/04.jpg"; // replace with your image
import "./home.css";

import Gallery from "../../components/Gallery/Gallery";
import HomeVideos from "../../components/HomeVideos/HomeVideos";

const Home = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: true,
          prevArrow: false,
          nextArrow: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false,
        },
      },
    ],
  };

  return (
    <>
      <Banner />
      <Features />

      {/* EXPERIENCE SECTION */}
      <section className="experience_section">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h2 className="experience_title">
                Discover journeys crafted with passion, comfort, and
                unforgettable moments.
              </h2>
              <p className="experience_text">
                BR Travel brings you thoughtfully designed travel experiences
                that go beyond destinations. From peaceful coastal escapes to
                cultural city explorations, every journey is curated to deliver
                comfort, authenticity, and lasting memories — without the rush,
                without the noise.
              </p>
              <Link to="/about" className="experience_btn">
                Explore our story
              </Link>
            </Col>
            <Col md={6}>
              <div className="experience_image">
                <img src={imgExperience} alt="Luxury Travel" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* HOME YOUTUBE VIDEOS */}
      <HomeVideos />

      {/* TESTIMONIALS */}
<section className="testimonials_section">
  <Container>
    {/* Heading */}
    <Row>
      <Col md={12} className="text-center">
        <h2 className="testimonial_heading">
          What Travelers Say About BR Travel
        </h2>
        <p className="testimonial_subheading">
          Real experiences shared by people who trusted us with their journeys.
        </p>
      </Col>
    </Row>

    {/* Testimonial Cards */}
    <Row className="mt-5 gx-4 gy-4"> {/* gx: horizontal gap, gy: vertical gap */}
      <Col md={4} sm={6}>
        <div className="testimonial_card">
          <h5>Ananya S.</h5>
          <div className="stars">★★★★★</div>
          <p>
            BR Travel made our vacation completely stress-free. Everything was
            well planned, from destinations to stays. It felt personal, not
            commercial, which made the experience truly special.
          </p>
        </div>
      </Col>

      <Col md={4} sm={6}>
        <div className="testimonial_card">
          <h5>Rahul K.</h5>
          <div className="stars">★★★★★</div>
          <p>
            What I loved most about BR Travel was their attention to detail.
            They understood exactly what we wanted and designed the trip around
            our preferences. Smooth, comfortable, and memorable.
          </p>
        </div>
      </Col>

      <Col md={4} sm={6}>
        <div className="testimonial_card">
          <h5>Neha P.</h5>
          <div className="stars muted">★★★★☆</div>
          <p>
            Beautiful destinations and well-organized plans. The team was
            responsive whenever we needed support. Overall, a great travel
            experience that I would happily recommend.
          </p>
        </div>
      </Col>
    </Row>

    {/* Dots */}
    <div className="testimonial_dots">
      <span></span>
      <span className="active"></span>
      <span></span>
      <span></span>
    </div>
  </Container>
</section>


      {/* CALL TO ACTION */}
      <section className="call_us">
        <Container>
          <Row className="align-items-center">
            <Col md="8">
              <h5 className="title">LET’S TRAVEL</h5>
              <h2 className="heading">Make Memories That Last Forever</h2>
              <p className="text">
                Explore incredible destinations and enjoy experiences crafted
                just for you.
              </p>
            </Col>
            <Col md="4" className="text-center mt-3 mt-md-0">
              <Link to="/contact" className="secondary_btn bounce">
                Contact Us
              </Link>
            </Col>
          </Row>
        </Container>
        <div className="overlay"></div>
      </section>

      {/* GALLERY */}
      <section className="gallery">
        <Container>
          <Row>
            <Col md="12">
              <div className="main_heading">
                <h1>Event Memories</h1>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Gallery />
            </Col>
          </Row>
        </Container>
      </section>

      {/* GOOGLE MAP SECTION */}
      <section className="map_section">
        <Container>
          <Row>
            <Col md={12}>
              <div className="main_heading">
                <h1>Visit Us</h1>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="map_container">
                <iframe
                  title="BR Travel Location"
                  src="https://www.google.com/maps?q=28.5441,77.2284&hl=en&z=16&output=embed"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
